import axios from 'axios';
import { ProgressReview, CreateProgressReviewDto } from '../types/progress-review.types';

export const progressReviewApi = {
  getAll: (tenantId: string, apprenticeId?: string, instructorEmail?: string) => {
    const params: any = {};
    if (apprenticeId) params.apprentice_id = apprenticeId;
    if (instructorEmail) params.instructor_email = instructorEmail;
    return axios.get<ProgressReview[]>(`/api/progress-reviews/tenant/${tenantId}`, { params });
  },

  getOne: (tenantId: string, id: string) => {
    return axios.get<ProgressReview>(`/api/progress-reviews/tenant/${tenantId}/${id}`);
  },

  create: (data: CreateProgressReviewDto) => {
    return axios.post<ProgressReview>('/api/progress-reviews', data);
  },

  update: (tenantId: string, id: string, data: Partial<ProgressReview>) => {
    return axios.patch<ProgressReview>(`/api/progress-reviews/tenant/${tenantId}/${id}`, data);
  },

  delete: (tenantId: string, id: string) => {
    return axios.delete(`/api/progress-reviews/tenant/${tenantId}/${id}`);
  },

  sign: (tenantId: string, id: string, signatureType: 'employer' | 'apprentice') => {
    return axios.post<ProgressReview>(`/api/progress-reviews/tenant/${tenantId}/${id}/sign`, {
      signature_type: signatureType,
    });
  },
};
